import watch from "../assets/images/monitor.svg";

const Watch = () => {
  return (
    <div className="bg-gray-900 sm:h-[50vh]">
      <div className="sm:w-[90%] sm:ml-auto sm:mr-auto sm:flex sm:justify-around items-center border-t-4 border-gray-700">
        <div className=" px-3 py-2">
          <h1 className="text-gray-300 font-extrabold md:text-left text-center py-2 text-xl md:text-3xl lg:text-6xl">
            Enjoy on your TV.
          </h1>

          <p className=" text-gray-300 text-base text-center sm:text-left sm:text-2xl max-w-lg">
            Watch on smart TVs, PlayStation, Xbox, Chromecast, Apple TV, Blu-ray
            players and more.
          </p>
        </div>
        <div className="px-3 py-2 p-3 mt-4 flex justify-center">
          <img src={watch} alt="" className="h-[300px]" />
        </div>
      </div>
    </div>
  );
};

export default Watch;
